<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.0022 0.200001H8.9978C4.1457 0.200001 0.199997 4.1468 0.199997 9C0.199997 10.925 0.820397 12.7092 1.8753 14.1579L0.778597 17.4271L4.1611 16.3458C5.5526 17.2676 7.2125 17.8 9.0022 17.8C13.8543 17.8 17.8 13.8521 17.8 9C17.8 4.1479 13.8543 0.200001 9.0022 0.200001Z"
            :fill="color"
        />
        <path
            d="M14.1227 12.6267C13.9104 13.2262 13.0678 13.7234 12.3957 13.8686C11.9359 13.9665 11.3353 14.0446 9.31349 13.2064C6.72739 12.135 5.06199 9.5071 4.93219 9.3366C4.80789 9.1661 3.88719 7.9451 3.88719 6.6823C3.88719 5.4195 4.52849 4.8046 4.78699 4.5406C4.99929 4.3239 5.35019 4.2249 5.68679 4.2249C5.79569 4.2249 5.89359 4.2304 5.98159 4.2348C6.24009 4.2458 6.36989 4.2612 6.54039 4.6693C6.75269 5.1808 7.26969 6.4436 7.33129 6.5734C7.39399 6.7032 7.45669 6.8792 7.36869 7.0497C7.28619 7.2257 7.21359 7.3038 7.08379 7.4534C6.95399 7.603 6.83079 7.7174 6.70099 7.878C6.58219 8.0177 6.44799 8.1673 6.59759 8.4258C6.74719 8.6788 7.26419 9.5225 8.02539 10.2001C9.00769 11.0746 9.80409 11.354 10.089 11.4728C10.3013 11.5608 10.5543 11.5399 10.7094 11.3749C10.9063 11.1626 11.1494 10.8106 11.3969 10.4641C11.5729 10.2155 11.7951 10.1847 12.0283 10.2727C12.2659 10.3552 13.5232 10.9767 13.7817 11.1054C14.0402 11.2352 14.2107 11.2968 14.2734 11.4057C14.335 11.5146 14.335 12.0261 14.1227 12.6267Z"
            fill="#FAFAFA"
        />
    </svg>
</template>
<script>
export default {
    name: "WhatsappSvg",
    props: {
        color: {
            type: String,
            default: "#4CAF50",
        },
    },
};
</script>

